import { gql } from 'graphql-request'

const UPDATE_APPLICATION = gql`
  mutation updateApplication(
    $id: ID!
    $name: String
    $platform: ApplicationPlatformEnum
    $rewardCallbackToken: String
    $rewardCallbackUrl: String
    $status: ApplicationStatusEnum
    $storeUrl: String
    $storeRefresh: Boolean
    $notInStore: Boolean
    $apiFeedEnabled: Boolean
    $apiFeedKeyRefresh: Boolean
    $rankingSourceAppId: ID
  ) {
    applicationUpdate(
      input: {
        id: $id
        attributes: {
          name: $name
          platform: $platform
          rewardCallbackToken: $rewardCallbackToken
          rewardCallbackUrl: $rewardCallbackUrl
          status: $status
          storeUrl: $storeUrl
          storeRefresh: $storeRefresh
          notInStore: $notInStore
          apiFeedEnabled: $apiFeedEnabled
          apiFeedKeyRefresh: $apiFeedKeyRefresh
          rankingSourceAppId: $rankingSourceAppId
        }
      }
    ) {
      application {
        id
        clientSecurityToken
        sdkSecurityToken
        name
        platform
        publisher {
          id
        }
        rewardCallbackToken
        rewardCallbackUrl
        status
        storeInfo
        storeUrl
        notInStore
        bundleId
        createdAt
        updatedAt
      }
      errors
    }
  }
`

export default UPDATE_APPLICATION
